export default __webpack_public_path__ + "static/media/img_password_sucess.b1b9be37.svg";